/** Same path as Report Calendar on the dashboard View all link. */
export const REPORT_CALENDAR_PATH = '/report-calendar'
